import React from 'react';

import axios from 'axios';

import {token, host} from '../assets/options';

class Logos extends React.Component {
    _isMounted = false;
    constructor(props){
        super(props);

        this.state = {
            partners: [],
        }
    }

    componentDidMount () {
        this._isMounted = true;

        axios.post(host + '/api/home/', {}, {headers: {'authorization': token}})
        .then(res => {
            if (res.status === 200) {
                if (this._isMounted) {
                    this.setState({
                        partners: res.data.data.partners,
                    });
                }
            } else {
              const error = new Error(res.data.error);
              throw error;
            }
        })
        .catch(err => console.error(err.response ? err.response.data.error : err)); 
    }

    componentWillUnmount () {
        this._isMounted = false;
    }
    
    render () {
        return (
            <div className="Logos_nav">
                <div className="logos_container">
                    <div className= "MyContainers">
                        {this.state.partners.map((partner, i)=>{
                            return <div key={i} className="LogoImgBlock">
                                <a href={partner.url} target="_blank" rel="noopener noreferrer">
                                    <img alt="logo" src={`${host}/public/uploads/${partner.img}`}/>
                                </a>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default Logos;